import React, { useRef } from "react";
import TYPE from "../../../constant/TYPE";
import { getMathJaxNode } from "../mathjax/MathJax";

const CollectAndSplit = ( props ) => {

  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  const startKeyword = `\\begin{${ TYPE.LATEX_CODE.COLLECT_AND_SPLIT }}`;
  const endKeyword = `\\end{${ TYPE.LATEX_CODE.COLLECT_AND_SPLIT }}`;
  const data = props.children.slice( props.children.indexOf( startKeyword ) + startKeyword.length, props.children.indexOf( endKeyword ) ).split( '\\\\' ).map( v => v.split( '&' ).map( v => v.trim() ) );
  const changedDataCount = data.reduce( ( r, v, i ) => r + v.filter( ( vv, ii ) => ( prevData.current[ i ] && prevData.current[ i ][ ii ] ) !== vv ).length, 0 );

  const MathJaxNode = getMathJaxNode( props.type );

  const mapRows = ( v, i ) => <tr key={ i }>{ v.map( mapColumns ) }</tr>;

  const mapColumns = ( value, index, origin ) => {
    return (
      <td key={ index } colSpan={ 1 === origin.length ? 2 : null }>
        <div className="inputBox-min">
          <span className="inputTxt"><MathJaxNode onRender={ renderMathJax }>{ value }</MathJaxNode></span>
        </div>
      </td>
    );
  };

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = data;
      mathjaxRenderCount.current = 0;
      props.onRender();
    }
  };

  const ROWS = data.map( mapRows );

  return (
    <table className="tbl-multiple">
      <colgroup>
        <col style={ { width : 40 } } />
        <col style={ { width : 40 } } />
      </colgroup>
      <tbody>
      { ROWS[ 0 ] }
      <tr key="2" className={ 1 === data[ 0 ].length ? null : 'multiple-reverse' }>
        <td className={ 1 === data[ 0 ].length ? 'd-left' : 'd-right' }>
          <div className="diagonal"><span className="line" /></div>
        </td>
        <td className={ 1 === data[ 0 ].length ? 'd-right' : 'd-left' }>
          <div className="diagonal"><span className="line" /></div>
        </td>
      </tr>
      { ROWS[ 1 ] }
      </tbody>
    </table>
  );

};

export default CollectAndSplit;
